// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SortSelectButton_wrapper__6z0Ij","text":"SortSelectButton_text__VA0Xh"};